export enum BuilderToggleDropdown {
  DIMENSIONS = "dimensions",
  INCLUSIONS = "inclusions",
  FLOORPLAN = "floorplan",
  FACADE = "facade",
}
